import { API_URL, API_KEY } from '../configs/global';

export const FETCH_POLYLINE = 'FETCH_POLYLINE';

export const fetchPolyline = (fromId, toId) => {

  const url = `${API_URL}/public-geometry-between-stops-v1/${fromId}/${toId}?api_key=${API_KEY}`;

  return dispatch => {
    fetch(url)
      .then(response => response.json())
      .then(response => dispatch({
        type: FETCH_POLYLINE,
        payload: response
      }))
      .catch(error => console.log(error))
  } 

}


// WEBPACK FOOTER //
// ./src/actions/PolylineAction.js